import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'fireauth-lib';
import { environment } from '../../../environments/environment';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const apiEndpoint = environment.cmsApiBaseUrl;

  const isApiRequest = req.url.startsWith(apiEndpoint);
  if (!isApiRequest) {
    return next(req);
  }

  return from(authService.getBearerToken()).pipe(
    switchMap(authToken => {
      if (authToken) {
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${authToken}` }
        });
        return next(authReq);
      }
      return next(req);
    })
  );
};
